import { render } from "./CustomerProductsDetail.vue?vue&type=template&id=f748fcaa&scoped=true&ts=true"
import script from "./CustomerProductsDetail.vue?vue&type=script&lang=ts"
export * from "./CustomerProductsDetail.vue?vue&type=script&lang=ts"

import "./CustomerProductsDetail.vue?vue&type=style&index=0&id=f748fcaa&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f748fcaa"]])

export default __exports__